import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
let sharelinkNotFoundElement;

function addViewDetailsCTAToEinstienProducts() {
    if($(sharelinkNotFoundElement).length) {
        let products = $(sharelinkNotFoundElement).find('.igo_product');
        if($(products).length) {
            let buttonText = $(sharelinkNotFoundElement).data('button-text');
            $(products).each(function () {
                var secondAnchor = $(this).find('a').eq(1);
                if(secondAnchor.length > 0 && $(this).find('a.view-details-cta').length === 0) {
                    var secondAnchorHref = secondAnchor.attr('href');
                    var newAnchor = $(`<a href="${secondAnchorHref}" class="view-details-cta">${buttonText}</a>`);
                    $(this).append(newAnchor);
                }
            });
        }
    }
}

function InitEventHandlers() {
    sharelinkNotFoundElement = $('#share-link-product-not-found');
    if($(sharelinkNotFoundElement).length) {
        einsteinLoad();
        loadSpinner();
        addViewDetailsCTAToEinstienProducts();
        setTimeout(() => stopSpinner(), 1500);
    }
}

$(function () {
    InitEventHandlers();
});

window.onload = function () {
    addViewDetailsCTAToEinstienProducts();
};

function einsteinLoad() {
    const parts = window.location.hostname.split('.');
    let scriptSrc = 'https://100035984.recs.igodigital.com/a/v2/100035984/product/recommend.js';
    if(parts.length > 0) {
        const pathSegments = window.location.href.split('/');
        if(pathSegments.length > 3) {
            const lg = pathSegments[3].toLowerCase();
            const naCodes = ['en-us', 'en-ca', 'en-pr', 'es-us', 'es-pr', 'fr-ca'];
            const anzCodes = ['en-au', 'en-nz'];

            if(naCodes.some(code => lg.includes(code))) {
                scriptSrc = 'https://100009517.recs.igodigital.com/a/v2/100009517/product/recommend.js';
            } else if(anzCodes.some(code => lg.includes(code))) {
                scriptSrc = 'https://100017896.recs.igodigital.com/a/v2/100017896/product/recommend.js';
            }
        }
    }

    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    scriptElement.src = scriptSrc;
    document.head.appendChild(scriptElement);
}
